import { useSyncExternalStore } from 'react';
import { getSuspension, subscribeSuspension, type Suspension } from '../lib/suspension-store.js';

/** Vue React du magasin de suspension. Le magasin reste la source ; ceci n'est qu'un abonnement. */
export function useSuspension(): Suspension | null {
  return useSyncExternalStore(subscribeSuspension, getSuspension, getSuspension);
}
